import Swal from "sweetalert2";

export const sweetAlert = (title = "Success", text = "Task success", icon = "success") => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "Close",
    timer: 3000,
    timerProgressBar: true,
  });
};

export const deleteAlert = async () => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    cancelButtonColor: "#ff0000",
    cancelButtonText: "Cancel",
  });

  return result.isConfirmed;
};
